import * as React from "react";

function SvgIcMedia(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M5.5 2.5C4.39543 2.5 3.5 3.39543 3.5 4.5V19.5C3.5 20.6046 4.39543 21.5 5.5 21.5H18.5C19.6046 21.5 20.5 20.6046 20.5 19.5V9.5C20.5 9.23478 20.3946 8.98043 20.2071 8.79289L14.2071 2.79289C14.0196 2.60536 13.7652 2.5 13.5 2.5H5.5ZM5.5 4.5H12.5V8.5C12.5 9.60457 13.3954 10.5 14.5 10.5H18.5V19.5H5.5V4.5ZM17.0858 8.5L14.5 5.91421V8.5H17.0858ZM8 7H10V9H8V7ZM7 7C7 6.44772 7.44772 6 8 6H10C10.5523 6 11 6.44772 11 7V9C11 9.55228 10.5523 10 10 10H8C7.44772 10 7 9.55228 7 9V7ZM6.5 13C6.5 12.4477 6.94772 12 7.5 12H16.5C17.0523 12 17.5 12.4477 17.5 13C17.5 13.5523 17.0523 14 16.5 14H7.5C6.94772 14 6.5 13.5523 6.5 13ZM7.5 15.5C6.94772 15.5 6.5 15.9477 6.5 16.5C6.5 17.0523 6.94772 17.5 7.5 17.5H16.5C17.0523 17.5 17.5 17.0523 17.5 16.5C17.5 15.9477 17.0523 15.5 16.5 15.5H7.5Z" fill="currentColor"/>
    </svg>
  );
}

export default SvgIcMedia;
